import React from 'react';
import { motion } from 'framer-motion';
import { fadeUp } from '../../utils/motion';
type InitiativeSectionProps = {
  id?: string;
  eyebrow?: string;
  title: string;
  tone?: 'white' | 'muted';
  intro?: string[];
  children?: React.ReactNode;
};

/** Two-column section used on initiative detail pages: heading left, copy right. */
export function InitiativeSection({
  id,
  eyebrow,
  title,
  tone = 'white',
  intro = [],
  children
}: InitiativeSectionProps) {
  const headingId = id ? `${id}-title` : undefined;
  return <section id={id} aria-labelledby={headingId} className={`${tone === 'muted' ? 'bg-surface-bg' : 'bg-white'} border-t border-line py-20 lg:py-28 scroll-mt-20`} data-id="element-1300" data-mp="7g1r77flv9n1">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-1301" data-mp="g7k5fcszrfdh">
        <motion.div {...fadeUp} className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16" data-id="element-1302" data-mp="g952b92s3aei">
          <div className="lg:col-span-5" data-id="element-1303" data-mp="3fsz7tsej3md0">
            {eyebrow && <p className="text-sm font-medium text-teal mb-3" data-id="element-1304" data-mp="3jvc47q7dy7x4">{eyebrow}</p>}
            <h2 id={headingId} className="font-heading font-bold text-3xl lg:text-4xl text-ink-dark tracking-tight leading-tight" data-id="element-1305" data-mp="2ooy59t9nk2qh">
              {title}
            </h2>
          </div>
          {intro.length > 0 && <div className="lg:col-span-7 space-y-5" data-id="element-1306" data-mp="2ewk534y8346f">
              {intro.map((paragraph, index) => <p key={paragraph} className={index === 0 ? 'text-xl text-ink-dark leading-relaxed' : 'text-lg text-ink-muted leading-relaxed'} data-id="element-1307" data-mp="29xpjjv8vf1im" data-mpi={index}>
                  {paragraph}
                </p>)}
            </div>}
        </motion.div>
        {children && <div className="mt-12 lg:mt-14" data-id="element-1308" data-mp="1r17lkw3fi5dx">{children}</div>}
      </div>
    </section>;
}